<template>
  <div v-loading="isLoading" class="rj-page-card">
    <div class="title">
      操作记录
    </div>
    <el-table border :data="tableData">
      <el-table-column prop="approveUserInfo" label="操作人" min-width="202.5" align="left">
        <template #default="{ row }">
          {{ row.approveUserInfo || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="approveName" label="操作动作" min-width="202.5" align="left">
        <template #default="{ row }">
          {{ row.approveName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="approveTime" label="操作时间" min-width="202.5" align="left">
        <template #default="{ row }">
          {{ row.approveTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="approveComment" label="驳回原因" min-width="202.5" align="left">
        <template #default="{ row }">
          {{ row.approveComment || '-' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getCeddChangeApprovalLog } from '@/API/international';

export default {
  name: 'OperationRecordHistory',
  props: {
    // 申请单号
    applicationId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      tableData: []
    };
  },
  methods: {
    getApproveLog () {
      this.isLoading = true;
      getCeddChangeApprovalLog(this.applicationId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  watch: {
    applicationId: {
      handler (applicationId) {
        if (applicationId) {
          this.getApproveLog();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #383838;
  margin-bottom: 12px;
}

</style>
